import { useMemo } from 'react';
import TableHead from './components/head/TableHead';
import TableBody from './components/body/TableBody';
import TableFooter from './components/footer/TableFooter';
import classes from './CustomTable.module.scss';
import { generateGrid } from './helpers';
import EmbedCard from './components/embedded/EmbedCard/EmbedCard';
import { TableContext } from './TableContext';

export { TableContext };

export default function CustomTable(props) {
  const {
    data,
    currentSection,
    columns,
    withHeader = true,
    withFooter = false,
    withExtraFooter = false,
    withActionController = false,
    withEmbedded = false,
    embedContent = '',
    embedAction = '',
    withLines,
    footerMargin,
    bodyWithBorderRadius,
    rowClickHandler = null,
    rowFocusInHandler = null,
    rowFocusOutHandler = null,
    wrapperStyles = { backgroundColor: '#FFFFFF', boxShadow: '0 0 30px rgba(61, 107, 149, 0.1)' },
    headerStyles = { borderRadius: '10px 10px 0 0' },
    bodyStyles = { padding: '20px 26px 0 26px' },
    footerStyles = {},
    extraFooterStyles = {},
    lineStyles = {},
    isLoading = false,
    loadingComponent,
    isApprover
  } = props;

  const gridStyles = generateGrid(props.columns);

  const contextValue = useMemo(
    () => ({
      data,
      currentSection,
      columns,
      gridStyles,
      withLines,
      rowClickHandler,
      rowFocusInHandler,
      rowFocusOutHandler,
      headerStyles,
      bodyStyles,
      footerStyles,
      extraFooterStyles,
      lineStyles,
      isApprover
    }),
    [
      data,
      currentSection,
      columns,
      gridStyles,
      withLines,
      headerStyles,
      rowClickHandler,
      rowFocusInHandler,
      rowFocusOutHandler,
      lineStyles,
      bodyStyles,
      isApprover
    ]
  );

  return (
    <TableContext.Provider value={contextValue}>
      <div className={classes.tableWrapper} style={wrapperStyles}>
        {withHeader && <TableHead />}
        {!isLoading ? <TableBody withBorderRadius={bodyWithBorderRadius} /> : loadingComponent}
        {withFooter && <TableFooter margin={footerMargin} />}
        {withExtraFooter && <TableFooter margin={footerMargin} withExtraFooter={withExtraFooter} />}
        {withActionController && <EmbedCard isActionable>{embedAction}</EmbedCard>}
        {withEmbedded && <EmbedCard>{embedContent}</EmbedCard>}
      </div>
    </TableContext.Provider>
  );
}
